<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog :close-on-click-modal="false" title="添加收款" :show-close="true" :visible="true"
    :before-close="handleBeforeClose" width="725px">
    <div class="dialog__container">

      <el-form class="search-form" label-position="right" label-width="100px" :ref="'formRef'" :model="formSelect"
        :rules="rulesSelect">
        <el-form-item label="应收类型:" prop="spendingList" class="input-with-col2 mr0">
          <el-select size="mini" multiple collapse-tags v-model="formSelect.spendingList" filterable placeholder="请选择支出项"
            clearable @change="selectSpendingChange" value-key="code">
            <el-option v-for="item in spendingList" :key="item.code" :label="item.name" :value="item"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="tag_box">
        <el-tag v-for="(tag, index) in tags" :key="tag.name" :type="showTagIndex == index ? '' : tag.type"
          style="margin:5px 5px;cursor: pointer;" @click="showTagIndex = index">
          {{ tag.name }}
        </el-tag>
      </div>


      <el-form inline :ref="'form' + index" v-for="(formListItem, index) in formList" :key="index"
        class="search-form search-form-new" v-show="showTagIndex == index" label-position="right" :model="formListItem"
        :rules="rules" label-width="100px">
        <el-form-item label="应收单据号:" prop="receiveNo" class="input-with-col2 mr0">
          <el-input size="mini" disabled v-model.trim="formListItem.receiveNo" placeholder="系统自动生成" clearable></el-input>
        </el-form-item>
        <el-form-item label="单据日期:" prop="billDate" class="input-with-col2 mr0">
          <el-date-picker v-model="formListItem.billDate" size="mini" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
            unlink-panels clearable></el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="应收类型:" prop="spending" class="input-with-col2 mr0">
          <el-select size="mini" v-model="formListItem.spending" filterable placeholder="请选择支出项" clearable
            value-key="code">
            <el-option v-for="item in spendingList" :key="item.code" :label="item.name" :value="item"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="客户:" prop="propertyUnit" class="input-with-col2 mr0">
          <el-select size="mini" v-model="formListItem.propertyUnit" filterable placeholder="请选择客户" clearable
            value-key="id">
            <el-option v-for="item in propertyUnitSimpleList" :key="item.id" :label="item.unitName"
              :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="总金额:" prop="inMoney" class="input-with-col2 mr0">
          <el-input size="mini" type="number" v-model.trim="formListItem.inMoney" placeholder="请输入总金额"
            clearable></el-input>
        </el-form-item>
        <el-form-item label="维保员:" prop="user" class="input-with-col2 mr0">
          <el-select size="mini" v-model="formListItem.user" filterable placeholder="请选择维保员" clearable value-key="userId">
            <el-option v-for="item in userList" :key="item.userId" :label="item.nickname" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="电梯信息:" prop="liftInfo" class="input-with-col2 mr0">
          <el-input size="mini" v-model.trim="formListItem.liftInfo" placeholder="请输入liftInfo" clearable></el-input>
        </el-form-item>
        <el-form-item label="配件费:" prop="proMoney" class="input-with-col2 mr0">
          <el-input size="mini" type="number" v-model.trim="formListItem.proMoney" placeholder="请输入配件费"
            clearable></el-input>
        </el-form-item>
        <el-form-item label="人工费:" prop="personMoney" class="input-with-col2 mr0">
          <el-input size="mini" type="number" v-model.trim="formListItem.personMoney" placeholder="请输入人工费"
            clearable></el-input>
        </el-form-item>
        <el-form-item label="备注:" prop="remark" class="input-with-col2 mr0">
          <el-input size="mini" v-model.trim="formListItem.remark" placeholder="请输入备注" clearable></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="plr28" size="mini" type="info" plain @click="handleCancel">取消</el-button>
      <el-button class="plr28" type="primary" size="mini" :loading="loadBtn" @click="handleConfirm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  saveReceive,
  saveReceiveList,
  userSimpleList,
  getReceiveTypeList,
  getPropertyUnitSimpleList
} from '@/api/Receive'
import {
  getCardList
} from '@/api/Card'

import cookies from '../../../libs/util.cookies'
export default {
  data() {
    return {
      spendingList: [],
      userList: [],
      cardList: [],
      propertyUnitSimpleList: [],
      form: {
        spending: {},
        propertyUnit: {},
        user: {},
        billDate: '',
        inMoney: '',
        proMoney: '',
        personMoney: '',
        liftInfo: '',
        remark: ''
      },
      formSelect: {
        spendingList: [],
      },
      showTagIndex: 0,
      rulesSelect: {
        spendingList: [
          {
            validator: (rule, value, callback) => {
              // 验证是否选择了应收类型，且不为空数组
              if (!value || value.length === 0) {
                callback(new Error("请选择应收类型"));
              } else {
                callback();  // 验证通过
              }
            },
            type: 'array',
            required: true,
            trigger: "change",  // 在选择发生变化时触发验证
          }
        ]
      },
      tags: [],
      formList: [

      ],
      rules: {
        billDate: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请选择日期"));
              } else {
                callback();
              }
            },
            required: true,
            trigger: "change"
          }
        ],
        inMoney: [{
          required: true,
          message: "请输入金额",
          trigger: "change",
        },],
        user: [
          {
            validator: (rule, value, callback) => {
              if (!value || !value.userId) {
                callback(new Error("请选择维保员信息"));
              } else {
                callback();
              }
            },
            required: true,
            trigger: "change"
          }
        ],
        propertyUnit: [
          {
            validator: (rule, value, callback) => {
              if (!value || !value.id) {
                callback(new Error("请选择客户"));
              } else {
                callback();
              }
            },
            required: true,
            trigger: "change"
          }
        ]
      },
      loadBtn: false,
    };
  },
  created() {
    this.handleSpendingList();
    this.handleUserSimpleList();
    this.handlePropertyUnitSimpleList();
  },
  methods: {
    async handleCardList() {
      const res = await getCardList({});
      if (res.code === 200) {
        this.cardList = res.data
      }
    },
    async handlePropertyUnitSimpleList() {
      const res = await getPropertyUnitSimpleList({});
      if (res.code === 200) {
        this.propertyUnitSimpleList = res.data
      }
    },
    async handleUserSimpleList() {
      const res = await userSimpleList({});
      if (res.code === 200) {
        this.userList = res.data
      }
    },
    async handleSpendingList() {
      const res = await getReceiveTypeList();
      if (res.code === 200) {
        this.spendingList = res.data
      }
    },
    inArray(needle, array) {
      for (var i = 0; i < array.length; i++) {
        if (needle === array[i]) {
          return true;
        }
      }
      return false;
    },
    handleBeforeClose(done) {
      this.$emit("cancel");
      done();
    },
    handleCancel() {
      this.$emit("cancel");
    },
    selectSpendingChange() {
      this.showTagIndex = 0;
      let newList = [];
      this.formSelect.spendingList.map((item, index) => {
        let flag = this.formList.some((items,) => {
          return items.name == item.name
        })
        console.log(flag, '-======')
        if (!flag) {
          newList.push(
            this.returnNewListItem(item, index)
          )
        } else {
          let aa = this.formList.find((items2) => { return items2.name == item.name });
          console.log(aa, '???')
          newList.push(aa)
        }
      })
      this.formList = newList;

      this.tags = this.formSelect.spendingList.map((item,) => {
        return { name: item.name, type: 'info' }
      })
      this.formSelect = { ...this.formSelect }
      console.log(this.formSelect, 'formSelect')
      console.log(this.formList, 'formList')
      console.log(this.tags, 'tags')
    },
    returnNewListItem(item, index) {
      let obj = {
        spending: this.formSelect.spendingList[index],
        name: item.name,
        propertyUnit: {},
        user: {},
        billDate: '',
        inMoney: '',
        proMoney: '',
        personMoney: '',
        liftInfo: '',
        remark: ''
      }
      return obj;
    },
    formatData(listData) {
      let arr = [];
      for (let i = 0; i < listData.length; i++) {
        const params = {
          ...listData[i]
        };
        params.type = params.spending.code;
        params.typeName = params.spending.name;
        params.propertyUnitId = params.propertyUnit.id;
        params.propertyUnitName = params.propertyUnit.unitName;
        params.repairUserId = params.user.userId;
        params.repairUserName = params.user.nickname;
        if (params.type != 30) {
          //delete params.repairUserId;
          //delete params.repairUserName;
          delete params.proMoney;
          delete params.personMoney;
          delete params.liftInfo;
        }
        delete params.propertyUnit;
        delete params.user;
        delete params.spending;
        console.log(params)
        console.log(params);
        arr.push(params);
      }
      return arr;
    },
    async handleConfirm() {
      console.log(this.form)
      if (this.loadBtn) return;

      let flag = true;
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) {
          flag = false;
        }
      })
      for (let i = 0; i < this.formList.length; i++) {
        const formRef = this.$refs['form' + i];
        formRef[0].validate(async (valid) => {
          if (!valid) {
            flag = false;
            return
          }
        })
      }
      if (!flag) {
        this.$message({
          type: 'warning',
          message: '存在未填写完整项，请填写'
        })
      } else {
        // 整理数据，调取新接口
        console.log(this.formList, "--hahaha--");
        let paramsList = this.formatData(this.formList);
        console.log(paramsList);
        const res = await saveReceiveList(paramsList);
        if (res.code === 200) {
          this.$message.success("添加成功");
          this.$emit("confirm");
        }
        this.loadBtn = false;
      }
    },
  },
};
</script>
<style>
.tag_box {
  padding: 10px 0;
}

.search-form-new {
  border: solid #ccc 1px;
  padding: 10px 5px 10px 30px;
  border-radius: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/ReceiveManagement/components/AddCause.vue